import React from "react";
import { Calendar } from "pages/booking/Calendar";

export const Booking: React.FC = () => {
    return (
        <div id="book_contents">
            <Calendar />
        </div>
    );
};
